import { render } from "./LibPage.vue?vue&type=template&id=4d0ec6c1&scoped=true"
import script from "./LibPage.vue?vue&type=script&lang=js"
export * from "./LibPage.vue?vue&type=script&lang=js"

import "./LibPage.vue?vue&type=style&index=0&id=4d0ec6c1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0ec6c1"]])

export default __exports__